import {
	_getAvailableProducts,
	calculateHasPermissionToInviteOrRequestAccess,
	type ProductSelectPerformanceMarkings,
} from './ProductSelectContext';

const EMPTY_PERFORMANCE_MARKINGS: ProductSelectPerformanceMarkings = {
	getInviteCapabilitiesStart: () => {},
	getInviteCapabilitiesEnd: () => {},
};

export const canInvitePeople = async ({
	resourceAri,
	cloudId,
	productId,
	jiraSubProduct,
	productIdWhitelist,
	onSuccess,
	onFail,
}: {
	resourceAri: string;
	cloudId: string;
	/**
	 * @param productId is the id of the product, @example jira
	 **/
	productId: string;
	/**
	 * @param jiraSubProduct is the id of the jira sub product that the experience is part of
	 **/
	jiraSubProduct?: string;
	/**
	 * @param productIdWhitelist is a list of specific product ids used to determine if the user has invite access, overriding the default behaviour that checks for any products
	 **/
	productIdWhitelist?: string[];
	onSuccess?: (resourceAri: string, availableResourcesAri: string[]) => void;
	onFail?: (resourceAri: string, errorMsg?: string, statusCode?: number) => void;
}): Promise<boolean> => {
	// NOTE: we use empty performance markings to prevent this hook from directly impacting our core metrics
	const { inviteCapabilities } = await _getAvailableProducts({
		cloudId,
		resourceAri,
		performance: EMPTY_PERFORMANCE_MARKINGS,
		onSuccess: onSuccess ? onSuccess : () => {},
		onFail: onFail ? onFail : () => {},
	});

	return calculateHasPermissionToInviteOrRequestAccess({
		cloudId: cloudId,
		productId: productId,
		jiraSubProduct: jiraSubProduct,
		inviteCapabilities,
		productIdWhitelist,
	});
};
